import Axios from '../utils/axios-utils';

// create Vehicle
export const createVehicle = async (data, accountId) => {
    try {
        const response = await Axios.post(`/accounts/${accountId}/vehicles`, {
            vin: data.vin,
            name: data.name,
            licensePlate: data.licensePlate,
            make: data.make,
            model: data.model,
            year: data.year,
            vehicleType: data.vehicleType,
            bodyClass: data.bodyClass,
            fuelType: data.fuelType,
            attributes: {
                color: data.color,
                // gps: data.gps 
            },
            note: data.note
        });

        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Create Vehicle error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Create Vehicle failed" }
        };
    }
};

// get all vehicles with page and limits
export const getAllVehicles = async (accountId, page = 1, limit = 10) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vehicles`, {
            params: { page, limit },
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Vehicles error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Vehicles failed" }
        };
    }
};

// get all vehicles list
export const getVehiclesMinimal = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vehicles/minimal`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Vehicles error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Vehicles failed" }
        };
    }
};


// delete Vehicle
export const deleteVehicle = async (accountId, vehicleId) => {
    try {
        const response = await Axios.delete(`/accounts/${accountId}/vehicles/${vehicleId}`);
        return {
            success: response.data.status === 'success',
            data: response.data,
            status: response.status
        };
    } catch (error) {
        console.log("Delete vehicle error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Delete vehicle failed" },
            status: error.response?.status || 500
        };
    }
};

// update Vehicle
export const updateVehicle = async (accountId, vehicleId, data) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/vehicles/${vehicleId}`, data);
        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update Vehicle error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update Vehicle failed" }
        };
    }
};

// get Vehicle
export const getVehicle = async (accountId, vehicleId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vehicles/${vehicleId}`);
        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Getting Vehicle error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Getting Vehicle failed" }
        };
    }
};

// update vehicle status
export const updateVehicleStatus = async (accountId, vehicleId, status) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/vehicles/${vehicleId}/status`, {
            status,
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update Vehicle Status error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update Vehicle Status failed" }
        };
    }
};





//********************************************** tabs apis **********************************************//


// get all vehicle fuels
export const getAllVehicleFuels = async (accountId, vehicleId, from, to) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vehicles/${vehicleId}/fuels`, {
            params: { from, to },
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Vehicle Fuels error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Vehicle Fuels failed" }
        };
    }
};

// get all vehicle meters
export const getAllVehicleMeters = async (accountId, vehicleId, from, to) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vehicles/${vehicleId}/meters`, {
            params: { from, to },
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Vehicle Meters error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Vehicle Meters failed" }
        };
    }
};

// get all vehicle types
export const getAllVehicleTypes = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vehicles/types`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Vehicle Types error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Vehicle Types failed" }
        };
    }
};

// get all vehicle bodies
export const getAllVehicleBodies = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vehicles/bodies`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Vehicle bodies error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Vehicle bodies failed" }
        };
    }
};

// get all vehicle makes
export const getAllVehicleMakes = async (accountId, search) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vehicles/makes`, {
            params: { search },
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Vehicle bodies error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Vehicle bodies failed" }
        };
    }
};

// get all vehicle statuses
export const getAllVehicleStatuses = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vehicles/statuses`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Vehicle statuses error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Vehicle statuses failed" }
        };
    }
};

// get all vehicle mdoels   
export const getAllVehicleModels = async (accountId, slug) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vehicles/makes/${slug}/models`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Vehicle models error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Vehicle models failed" }
        };
    }
};

// get all vehicle medias   
export const getAllVehicleMedia = async (accountId, vehicleId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vehicles/${vehicleId}/media`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Vehicle Media error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Vehicle Media failed" }
        };
    }
};


// get all vehicle Expenses
export const getAllVehicleExpenses = async (accountId, vehicleId, from, to) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vehicles/${vehicleId}/expenses`, {
            params: { from, to },
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Vehicle Expenses error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Vehicle Expenses failed" }
        };
    }
};

// get all vehicle Incidents
export const getAllVehicleIncidents = async (accountId, vehicleId, from, to) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vehicles/${vehicleId}/incidents`, {
            params: { from, to },
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Vehicle incidents error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Vehicle incidents failed" }
        };
    }
};

// get all vehicle tires
export const getAllVehicleTires = async (accountId, vehicleId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vehicles/${vehicleId}/tires`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Vehicle tires error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Vehicle tires failed" }
        };
    }
};

// get all vehicle Services
export const getAllVehicleServices = async (accountId, vehicleId, from, to) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vehicles/${vehicleId}/services`, {
            params: { from, to },
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Vehicle Services error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Vehicle Services failed" }
        };
    }
};


// get all vehicle reminders
export const getAllVehicleReminders = async (accountId, vehicleId, from, to, linkedType) => {
    try {
        const params = { from, to }; // always include from & to

        if (linkedType) {
            params.linkedType = linkedType; // only add if value exists
        }

        const response = await Axios.get(
            `/accounts/${accountId}/vehicles/${vehicleId}/reminders`,
            { params }
        );

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All vehicle reminders Services error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All vehicle reminders Services failed" }
        };
    }
};



// get all vehicle overview
export const getVehicleOverview = async (accountId, vehicleId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vehicles/${vehicleId}/overview`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get Vehicle Overview error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get Vehicle Overview failed" }
        };
    }
};


// get all vehicle renewals
export const getAllVehicleRenewals = async (accountId, vehicleId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vehicles/${vehicleId}/renewals`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All vehicle Renewals Services error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All vehicle Renewals Services failed" }
        };
    }
};